import { connect } from 'react-redux';

import BreadcrumbContentRenderer from '../../shared/displayComponents/breadcrumbContentRenderer/breadcrumbContentRenderer.component';
import { entityIdSelector, isFetchingEntitiesSelector } from '../../shared/store/selectors';

export default connect(state => ({
  label: entityIdSelector(state),
  isLoading: isFetchingEntitiesSelector(state),
}))(BreadcrumbContentRenderer);
